<template>
  <div class="main-layout">
    <el-card class="box-form box-outter">
      <c-title slot="header" :title="title"></c-title>
      <div class="div-scroll">
        <el-row class="add-form" style="width: 80%; margin: 0 auto">
          <el-form
            size="small"
            :model="handleData"
            ref="cForm"
            :rules="formRules"
            :label-width="'150px'"
          >
            <el-col :span="24">
              <c-form-item :formItems="formItems" />
            </el-col>
            <el-col :span="24" style="text-align: center">
              <el-form-item label-width="0">
                <slot name="other">
                  <el-button type="primary" @click="submit" size="medium"
                    >提交</el-button
                  >
                </slot>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import CTitle from "@/components/CTitle";
import CFormItem from "@/components/CForm/CFormItem.vue";
import Configs from "./data/teacher.js";
import MHandle from "@/mixins/MHandle.js";
let mHandle = MHandle({
  handleGetPath: "/account/base/teacher",
  handleInsertPath: "/account/base/teacher/save",
  handleUpdatePath: "/account/base/teacher/update",
  handleDownLoadPath: "",
  handleData: {
    img: "",
    teacherId: "",
    name: "",
    idCardType: "",
    idCard: "",
    dateBirth: "",
    sex: "",
    phoneNumber: "",
    politicalCode: "",
    marriageStatus: "",
    nationCode: "",
    addressAreaCode: "",
    addressInfo: "",
  },
});
export default {
  components: { CFormItem, CTitle },
  mixins: [mHandle],
  data() {
    let { formItems, formRules } = Configs(this);
    return {
      title: "",
      value: {},
      formItems,
      formRules,
      // value: {},
      // action: "http://61.184.241.22:8088/zlf/upload?prefix=appointment",
    };
  },
  provide() {
    return {
      cForm: this,
    };
  },
  created() {
    let id = this.$route.params.id;
    if (id) {
      this.title = "编辑";
      this.id = id;
      this.handleGet(this.id);
    } else {
      this.title = "新增";
    }
  },
  watch: {
    handleData: {
      handler(val) {
        console.log(val);
        this.value = val;
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  beforeDestroy() {
    this.$refs.cForm.resetFields();
  },
  methods: {
    submit(fn) {
      this.$refs.cForm.validate((valid) => {
        if (valid) {
          //   验证通过后将数据提交保存
          if (this.handleData.id) {
            this.handleUpdate();
          } else {
            this.handleInsert();
          }
        } else {
          return false;
        }
      });
    },
    beforeAvatarUpload(file) {
      console.log(file);
    },
    handleAvatarRemove() {
      this.handleData.img = null;
    },
    handleAvatarSuccess(res, file) {
      console.log(res);
      this.handleData.img = res.fileUrl;
      console.log(this.handleData.img);
    },
  },
};
</script>

